import { useSelector } from "react-redux";

import { FreshpaintState } from "../reducers";
import { AccountMetadata } from "../reducers/environments";

export default function useAccountMetadata(): AccountMetadata & {
  loaded: boolean;
} {
  return useSelector((state: FreshpaintState) => {
    return {
      ...state.environments.accountMetadata,
      loaded: state.environments.loaded,
    };
  });
}
